import * as React from 'react';
import { TERMS_AND_CONDITION_SECTIONS } from '../constants/terms';

class TermsContent extends React.Component {
  render() {
    return (
      <>
        {TERMS_AND_CONDITION_SECTIONS.map((section, sectionIndex) => (
          <React.Fragment key={sectionIndex}>
            <h4>{section.title}</h4>
            {section.data.map((paragraph, paragraphIndex) => (
              <p key={paragraphIndex}>{paragraph}</p>
            ))}
          </React.Fragment>
        ))}
      </>
    );
  }
}

export default TermsContent;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/TermsContent.tsx